import { useEffect, useRef } from 'react';

export default function useOnValueChange(value, onChange) {
	const prevValue = useRef();
	useEffect(() => {
		if (prevValue.current !== value) {
			prevValue.current = value;
			onChange(value);
		}
	}, [onChange, value]);
}
